import React from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentCityPhone } from '@r1-frontend/entities/stores/city/selectors';

import * as ST from './styled';

const PhoneInfo = () => {
    const { href, hasPhoneData, callCenter } = useSelector(selectCurrentCityPhone);

    if (!callCenter || !hasPhoneData) {
        return null;
    }

    return (
        <ST.CityPhone
            href={href}
            className='js-calltouch-phone'
            data-test='phone'
        >
            {callCenter}
        </ST.CityPhone>
    );
};

export default PhoneInfo;
